import { render, staticRenderFns } from "./ProjectDeliverableList.vue?vue&type=template&id=beff0ede&"
import script from "./ProjectDeliverableList.vue?vue&type=script&lang=js&"
export * from "./ProjectDeliverableList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.cabcom.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('beff0ede')) {
      api.createRecord('beff0ede', component.options)
    } else {
      api.reload('beff0ede', component.options)
    }
    module.hot.accept("./ProjectDeliverableList.vue?vue&type=template&id=beff0ede&", function () {
      api.rerender('beff0ede', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverables/ProjectDeliverableList.vue"
export default component.exports